import { useQuery } from "react-query";
import ReviewSlide from "../../../components/ReviewSlide";
import SpinnerDot from "../../../components/SpinnerDot";

function Reviews() {
  const { data: reviews } = useQuery("reviews", () => {
    return fetch(`${process.env.REACT_APP_SERVER_ENDPOINT}/reviews`).then(
      (res) => res.json()
    );
  });

  return (
    <section className="text-center">
      <h2>What Our Customers Say About Us...</h2>

      <div className="py-8">
        <div class="carousel w-full">
          {!reviews ? (
            <SpinnerDot />
          ) : (
            reviews.map(({ _id, name, institution, rating, review }, index) => {
              const isFirst = index === 0,
                isLast = reviews.length === index + 1;

              return (
                <ReviewSlide
                  key={_id}
                  slide={index}
                  next={isLast ? 0 : index + 1}
                  previous={isFirst ? review.length - 1 : index - 1}
                  rating={rating}
                >
                  <p>
                    <em className="text-sm">{review}</em>
                  </p>

                  <h3>{name}</h3>

                  <h4 className="font-light">{institution}</h4>
                </ReviewSlide>
              );
            })
          )}
        </div>
      </div>
    </section>
  );
}

export default Reviews;
